<template>
  <div>
    <van-cell-group id="form_cell_group">
      <h3 class="cell_title">营业信息</h3>
      <van-field
        v-if="reg_mer_type !== '05'"
        key="licenseImg"
        name="business_license_img"
        label="营业执照"
        :rules="[{ validator: uploadValidator, message: '请上传营业执照' }]"
      >
        <template #input>
          <CellUpload
            enums="BUSINESS_LICENSE"
            text="营业执照"
            type="0002"
            v-model="businessFormObj.business_license_img"
            name="商户营业执照"
            @change="uploadChange"
          />
        </template>
      </van-field>
      <van-field
        key="shopName"
        name="shop_name"
        v-model="businessFormObj.shop_name"
        label="营业名称"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入营业执照上的商户名称' }]"
      />
      <van-field
        key="shopArea"
        name="shop_country_id"
        :value="businessFormObj.shop_country_id"
        label="营业地址"
        :rules="[{ required: true, message: '请选择营业地址' }]"
      >
        <template #input>
          <van-cell
            class="date_cell"
            is-link
            @click="openAreaPopup"
            :value="areaText"
          />
        </template>
      </van-field>
      <van-field
        v-show="false"
        key="areaText"
        name="areaText"
        v-model="areaText"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :loading="areaLoding"
          :area-list="areaList"
          :value="businessFormObj.shop_country_id"
          :columns-placeholder="['请选择', '请选择', '请选择']"
          @change="areaChange"
          @confirm="areaConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        key="shopAddr"
        name="shop_addr_ext"
        v-model="businessFormObj.shop_addr_ext"
        label="补充地址"
        placeholder="请输入"
        :rules="[
          { required: true, message: '请填写地址补充说明部分' },
          {
            pattern: /.{5,50}$/,
            message: '补充地址5-50个字符',
            trigger: 'onBlur',
          },
        ]"
      />
      <van-field
        key="shopIndustry"
        name="mccCode"
        label="所属行业"
        :value="businessFormObj.mccCode"
        :rules="[{ required: true, message: '请选择所属行业' }]"
      >
        <template #input>
          <search-picker
            v-model="businessFormObj.mccCode"
            :columns="professionArr"
            @openSearchPick="openMccCodePick"
          />
        </template>
      </van-field>
      <div v-if="reg_mer_type !== '02' && reg_mer_type !== ''">
        <van-field
          key="shopLic"
          name="shop_lic"
          v-model="businessFormObj.shop_lic"
          label="社会统一代码"
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写社会统一代码' }]"
        />
        <van-field
          v-if="reg_mer_type !== '05'"
          key="licenseType"
          name="zwBusinessLicenseType"
          label="营业执照类型"
          :value="businessFormObj.zwBusinessLicenseType"
          :rules="[{ required: true, message: '请选择营业执照类型' }]"
        >
          <template #input>
            <select-popup
              v-model="businessFormObj.zwBusinessLicenseType"
              :columns="[
                { text: '多合一营业执照', value: 1 },
                { text: '普通营业执照', value: 2 },
              ]"
            />
          </template>
        </van-field>
        <van-field
          v-if="
            businessFormObj.zwBusinessLicenseType === 2 && reg_mer_type !== '05'
          "
          key="taxImg"
          name="tax_img"
          label="税务登记证"
          :rules="[{ validator: uploadValidator, message: '请上传税务登记证' }]"
        >
          <template #input>
            <CellUpload
              text="税务登记证"
              type="0003"
              v-model="businessFormObj.tax_img"
              name="商户税务登记证"
            />
          </template>
        </van-field>
        <van-field
          v-if="
            businessFormObj.zwBusinessLicenseType === 2 && reg_mer_type !== '05'
          "
          key="organizationImg"
          name="organization_img"
          label="组织机构代码证"
          :rules="[
            { validator: uploadValidator, message: '请上传组织机构代码证' },
          ]"
        >
          <template #input>
            <CellUpload
              text="组织机构代码证"
              type="0004"
              v-model="businessFormObj.organization_img"
              name="商户组织机构代码证"
            />
          </template>
        </van-field>
        <van-field
          v-if="reg_mer_type === '05'"
          key="unregisteredImg"
          name="business_unregistered_img"
          label="民办非登记证书"
          :rules="[
            { validator: uploadValidator, message: '请上传民办非登记证书' },
          ]"
        >
          <template #input>
            <CellUpload
              text="民办非登记证书"
              type="0032"
              v-model="businessFormObj.business_unregistered_img"
              name="民办非登记证书"
            />
          </template>
        </van-field>
        <van-field
          key="doorImg"
          name="door_img"
          label="门头照片"
          :rules="[{ validator: uploadValidator, message: '请上传门头照片' }]"
        >
          <template #input>
            <CellUpload
              text="门头照片"
              type="0005"
              v-model="businessFormObj.door_img"
              name="门头照片"
            />
          </template>
        </van-field>
        <van-field
          key="storeImg"
          name="store_img"
          label="店内照片"
          :rules="[{ validator: uploadValidator, message: '请上传店内照片' }]"
        >
          <template #input>
            <CellUpload
              text="店内照片"
              type="0022"
              v-model="businessFormObj.store_img"
              name="店内照片"
            />
          </template>
        </van-field>
        <van-field
          v-for="(item, index) in businessFormObj.assist_img_list"
          :key="item.type"
          :name="item.name"
          :label="'辅助证明材料' + (index + 1) + '/3'"
        >
          <template #input>
            <CellUpload
              :text="'辅助证明材料' + (index + 1)"
              :type="item.type"
              v-model="item.value"
              :name="'辅助证明材料' + (index + 1)"
            />
          </template>
        </van-field>
        <van-field
          key="isStockholder"
          name="zwShareholderIsJuridicalPerson"
          label="控股股东是否为法人"
          :value="businessFormObj.zwShareholderIsJuridicalPerson"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <select-popup
              v-model="businessFormObj.zwShareholderIsJuridicalPerson"
              :columns="[
                { text: '是', value: '1' },
                { text: '否', value: '0' },
              ]"
            />
          </template>
        </van-field>
        <user-form
          v-if="businessFormObj.zwShareholderIsJuridicalPerson === '0'"
          key="stockholder"
          nameText="控股股东"
          name="shareholderName"
          typeName="shareholderCertType"
          codeName="shareholderCertno"
          beginTimeName="shareholderCertBeginDate"
          endTimeName="shareholderCertExpire"
          addrName="shareholderHomeAddr"
          :formObj="formObj"
        />
        <!-- <van-field
          key="isBeneficiary"
          name="zwBeneficiaryIsJuridicalPerson"
          label="受益人是否为法人"
          :value="businessFormObj.zwBeneficiaryIsJuridicalPerson"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <select-popup
              v-model="businessFormObj.zwBeneficiaryIsJuridicalPerson"
              :columns="[
                { text: '是', value: '1' },
                { text: '否', value: '0' },
              ]"
            />
          </template>
        </van-field> -->
        <user-form
          key="beneficiary"
          nameText="受益人"
          name="bnfName"
          typeName="bnfCertType"
          codeName="bnfCertno"
          beginTimeName="bnfCertBeginDate"
          endTimeName="bnfCertExpire"
          addrName="bnfHomeAddr"
          phoneName="bnfMobile"
          sexName="bnfSex"
          birthdayName="bnfBirthday"
          nationName="bnfNationality"
          natrlName="bnfNatrlPrsn"
          :formObj="formObj"
        />
        <van-field
          v-if="businessFormObj.zwShareholderIsJuridicalPerson === '1'"
          key="homeAddr"
          name="homeAddr"
          v-model="businessFormObj.homeAddr"
          label="法人家庭地址"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入法人家庭地址' }]"
        />
      </div>
    </van-cell-group>
    <van-cell-group
      id="form_cell_group_xw"
      v-if="reg_mer_type == '02' && reg_mer_type !== ''"
    >
      <h3 class="cell_title">
        <span>小微商户证明信息</span>
        <span class="title_tips" v-show="$route.query.type === '1'"
          >至少上传一张证明材料图片</span
        >
      </h3>
      <van-field
        ref="xwAssistRef"
        v-for="item in businessFormObj.xw_assist_img_list"
        :key="item.type"
        :name="item.name"
        :label="item.label"
        :rules="[
          { validator: xwValidator, message: '至少上传一张证明材料图片' },
        ]"
      >
        <template #input>
          <CellUpload
            :text="item.label"
            :type="item.type"
            :name="item.label"
            v-model="item.value"
            @validate="xwUploadChange"
          />
        </template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import SelectPopup from "./SelectPopup";
import SearchPicker from "./SearchPicker";
import CellUpload from "./CellUpload";
import UserForm from "./UserForm";
export default {
  name: "BusinessInfo",
  components: {
    SelectPopup,
    CellUpload,
    SearchPicker,
    UserForm,
  },
  props: ["reg_mer_type", "formObj", "changePictureItem", "partnerInfo"],
  data() {
    return {
      businessFormObj: {
        shop_name: "",
        shop_country_id: "",
        shop_addr_ext: "",
        mccCode: "",
        shop_lic: "",
        zwBusinessLicenseType: 1,
        business_license_img: {
          document_name: "商户营业执照",
          document_type: "0002",
        },
        tax_img: {
          document_name: "商户税务登记证",
          document_type: "0003",
        },
        organization_img: {
          document_name: "商户组织机构代码证",
          document_type: "0004",
        },
        door_img: {
          document_name: "门头照片",
          document_type: "0005",
        },
        store_img: {
          document_name: "店内照片",
          document_type: "0022",
        },
        business_unregistered_img: {
          document_name: "民办非登记证书",
          document_type: "0032",
        },
        zwShareholderIsJuridicalPerson: "1",
        assist_img_list: [
          {
            value: {
              document_name: "辅助证明材料1/3",
              document_type: "0008",
            },
            name: "assist_img_list1",
            type: "0008",
          },
          {
            value: {
              document_name: "辅助证明材料2/3",
              document_type: "0013",
            },
            name: "assist_img_list2",
            type: "0013",
          },
          {
            value: {
              document_name: "辅助证明材料3/3",
              document_type: "0014",
            },
            name: "assist_img_list3",
            type: "0014",
          },
        ],
        xw_assist_img_list: [
          {
            value: {
              document_name: "租赁协议",
              document_type: "0016",
            },
            label: "租赁协议",
            name: "xw_assist_img_1",
            type: "0016",
          },
          {
            value: {
              document_name: "产权证明",
              document_type: "0017",
            },
            label: "产权证明",
            name: "xw_assist_img_2",
            type: "0017",
          },
          {
            value: {
              document_name: "执业资质证照",
              document_type: "0018",
            },
            label: "执业资质证照",
            name: "xw_assist_img_3",
            type: "0018",
          },
          // {
          //   value: {
          //     document_name: "第三方证明",
          //     document_type: "0019"
          //   },
          //   label: "第三方证明",
          //   name: "xw_assist_img_4",
          //   type: "0019",
          // },
          // {
          //   value: {
          //     document_name: "其他证明材料",
          //     document_type: "0020"
          //   },
          //   label: "其他证明材料",
          //   name: "xw_assist_img_5",
          //   type: "0020",
          // },
        ],
        homeAddr: "",
      },

      showArea: false,
      areaLoding: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      areaText: "",
      professionArr: [],
    };
  },
  created() {
    if (this.$route.query.type === "1" && this.xw_assist_img_list) {
      this.xw_assist_img_list.push({
        value: {
          document_name: "第三方证明",
          document_type: "0019",
        },
        label: "第三方证明",
        name: "xw_assist_img_4",
        type: "0019",
      });
    }
  },
  watch: {
    "businessFormObj.shop_country_id": {
      async handler(newV, oldV) {
        let provinceCode = newV.slice(0, 2);
        let cityCode = newV.slice(0, 4);
        if (JSON.stringify(this.areaList.province_list) == "{}")
          await this.getAreaArr("", 0);
        if (JSON.stringify(this.areaList.city_list) == "{}")
          await this.getAreaArr(provinceCode, 1);
        if (JSON.stringify(this.areaList.county_list) == "{}")
          await this.getAreaArr(cityCode, 2);
        this.areaText = `${this.areaList.province_list[provinceCode]}-${this.areaList.city_list[cityCode]}-${this.areaList.county_list[newV]}`;
      },
      deep: true,
    },
    "businessFormObj.mccCode": {
      async handler(newV, oldV) {
        if (this.professionArr.length === 0) await this.getProfessionArr();
        let item = this.professionArr.filter(
          (item) =>
            item.value === JSON.parse(this.businessFormObj.mccCode).value
        );
        this.businessFormObj.mccCode = item[0]
          ? JSON.stringify(item[0])
          : JSON.stringify({ value: "", text: "" });
      },
      deep: true,
    },
    formObj: {
      handler(newV, oldV) {
        for (const key in this.businessFormObj) {
          if (this.businessFormObj[key] instanceof Object) {
            if (key === "assist_img_list" || key === "xw_assist_img_list") {
              this.businessFormObj[key].forEach((item) => {
                let pictureItem = newV.picture.filter(
                  (i) => i.type === item.type
                );
                if (pictureItem.length > 0) {
                  item.value = {
                    ...item.value,
                    file_path: pictureItem[0].tripartitePath,
                    file_size: pictureItem[0].pictureSize,
                    url: pictureItem[0].fastPath,
                  };
                }
              });
            } else {
              let pictureItem = newV.picture.filter(
                (i) => i.type === this.businessFormObj[key].document_type
              );
              if (pictureItem.length > 0) {
                this.businessFormObj[key] = {
                  ...this.businessFormObj[key],
                  file_path: pictureItem[0].tripartitePath,
                  file_size: pictureItem[0].pictureSize,
                  url: pictureItem[0].fastPath,
                };
              }
            }
          } else if (key === "zwShareholderIsJuridicalPerson") {
            this.businessFormObj[key] = newV.commitData[key] ? "1" : "0";
          } else if (key === "mccCode") {
            let mccCode = newV.commitData.complexUploadBasic.mccCode;
            this.businessFormObj.mccCode = JSON.stringify({
              value: mccCode ? mccCode : "",
              text: "",
            });
          } else if (key === "homeAddr") {
            this.businessFormObj.homeAddr =
              newV.commitData.complexUploadBasic.shareholderHomeAddr ||
              newV.commitData.complexUploadBasic.legalmanHomeAddr;
          } else if (Object.hasOwnProperty.call(newV.commitData, key)) {
            this.businessFormObj[key] = newV.commitData[key];
          } else if (
            Object.hasOwnProperty.call(newV.commitData.complexUploadBasic, key)
          ) {
            this.businessFormObj[key] = newV.commitData.complexUploadBasic[key];
          }
        }
      },
      deep: true,
    },
    changePictureItem: {
      handler(newV, oldV) {
        if (newV.document_type === "0002") {
          this.businessFormObj.business_license_img = newV;
        }
      },
      deep: true,
    },
    partnerInfo: {
      handler(newV, oldV) {
        this.realNameFormObj = {
          ...this.realNameFormObj,
          ...newV,
        };
      },
      deep: true,
    },
  },
  methods: {
    uploadValidator(value, rule) {
      return value[0].file_path && value[0].file_path !== "" ? true : false;
    },
    findKeyByValue(obj, value) {
      if (value === "香港特别行政区") {
        return Object.keys(obj).find((key) => obj[key] === "香港");
      }
      return Object.keys(obj).find((key) => obj[key] === value);
    },
    async uploadChange(query) {
      await this.getAreaArr("", 0);
      let provinceKey = this.findKeyByValue(
        this.areaList.province_list,
        query.province
      );
      await this.getAreaArr(provinceKey, 1);
      let cityKey = this.findKeyByValue(
        this.areaList.city_list,
        query.city ? query.city : query.province
      );
      await this.getAreaArr(cityKey, 2);
      this.businessFormObj.shop_name = query.companyName;
      this.businessFormObj.shop_lic = query.creditCode;
      this.businessFormObj.shop_country_id = this.findKeyByValue(
        this.areaList.county_list,
        query.area
      );
      query.closeLoding();
    },
    xwUploadChange() {
      this.$refs.xwAssistRef.forEach((item) => {
        item.validate();
      });
    },
    xwValidator() {
      return (
        this.$route.query.type === "2" ||
        this.businessFormObj.xw_assist_img_list.some(
          (item) => item.value.file_path && item.value.file_path !== ""
        )
      );
    },
    openMccCodePick() {
      if (this.professionArr.length === 0) this.getProfessionArr();
    },
    openAreaPopup() {
      if (JSON.stringify(this.areaList.province_list) == "{}")
        this.getAreaArr("", 0);
      this.showArea = true;
    },
    areaChange(_, pickValue, index) {
      this.getAreaArr(pickValue[index].code, index + 1);
    },
    areaConfirm(value) {
      if (value.every((item) => item && item.code !== "")) {
        this.businessFormObj.shop_country_id = value[2].code;
        this.showArea = false;
      }
    },
    async getAreaArr(params, type) {
      if (type === 3) return;
      let areaObj = {};
      this.areaLoding = true;
      const res = await this.$apis.zzsignServe.getArea({ code: params });
      if (res.resultCode === "200") {
        res.data.forEach((item) => {
          areaObj[item.code] = item.name;
        });
        switch (type) {
          case 0:
            this.areaList.province_list = areaObj;
            this.areaList.city_list = {};
            this.areaList.county_list = {};
            break;
          case 1:
            this.areaList.city_list = areaObj;
            this.areaList.county_list = {};
            break;
          case 2:
            this.areaList.county_list = areaObj;
            break;
        }
        this.areaLoding = false;
      }
    },
    async getProfessionArr() {
      const res = await this.$apis.zzsignServe.getProfession();
      if (res.resultCode === "200") {
        this.professionArr = res.data.map((item) => ({
          text: item.mccname,
          value: item.mcccode,
        }));
      }
    },
  },
};
</script>

<style scoped lang="scss">
#form_cell_group,
#form_cell_group_xw {
  margin-top: 24px;

  .cell_title {
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin: 13px 0 3px;

    .title_tips {
      display: inline-block;
      margin-left: 10px;
      padding: 5px 9px 4px;
      background: #ffecec;
      border-radius: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #ff132f;
      line-height: 17px;
    }
  }

  .date_cell {
    padding: 0;
    border: none;

    &::v-deep .van-cell__value {
      text-align: right;
    }
  }

  .date_popup_check {
    margin: 22px 0;
    justify-content: center;
  }

  .to_cell_box {
    padding: 0;
    width: 100%;
    justify-content: end;
  }
}
</style>
